var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-class page-home"},[_c('b-container',{staticClass:"text-center my-5"},[_c('h1',[_vm._v("TokenSystems")]),_c('p',{staticClass:"lead"},[_vm._v("Hier erhalten Sie die Übersicht über Ihre Assets")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }